import Swal from "sweetalert2";
import { Link, useMatch } from "react-router-dom";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import Profile from "../assets/images/profile_placeholder.png";
import { Spinner } from "../components/BootstrapCompo";
const ReactQuill =
  typeof window === "object" ? require("react-quill") : () => false;

export default () => {
  const { authState, authDispatch } = useContext(GlobalContext);
  if(authState.access_token){henceforthApi.setToken(authState.access_token);}
  const [loading, setLoading] = useState(false);

  const [file_name, setFileName] = useState(false);
  const { type } = useParams();
  const [state, setState] = useState({
    created_at: "",
    image_url: "",
    type: "",
    title: "",
    updated_at: "",
    _id: "",
  });
  const [description, setDesciption] = useState("");
  const handleUpload = async (e: any) => {
    let file = e.target.files[0]
    setLoading(true);
    const apiRes = await (henceforthApi.Auth.uploadImage("file", file)).data;
    setFileName(apiRes.data.file_name);
    setState({
      ...state,
      image_url: apiRes.data.file_name,
    });
    const data = {
      type: state.type,
      image_url: apiRes.data.file_name,
      description: description,
      title: state.title,
      language: "ENGLISH",
    };
    henceforthApi.Policies.addEditPolicy(data)
      .then((res: any) => {
        setLoading(false);
        console.log(res);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const data = {
      type: state.type,
      title: state.title,
      description: description,
      language: "ENGLISH",
    } as any;
    if (state.image_url) {
      data["image_url"] = state.image_url;
    }
    henceforthApi.Policies.addEditPolicy(data)
      .then((res: any) => {
        setLoading(false);
        console.log(res);
        Swal.fire({
          title: "Content updated",
          text: "Content updated successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        window.history.back();
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text:
            typeof err.response.body.error_description == "string"
              ? err.response.body.error_description
              : JSON.stringify(err.response.body.error_description),
          icon: "error",
          confirmButtonText: "Cancel",
        });
      });
  };
  const initialiseData = async () => {
    try {
      let apiRes = await henceforthApi.Policies.byType(state.type);
      let obj =
        Array.isArray(apiRes.data.data) && apiRes.data.data.length
          ? apiRes.data.data[0]
          : apiRes.data.data;
      setState({
        ...state,
        ...obj,
      });
      setDesciption(obj.description);
    } catch (error: any) { }
  };

  useEffect(() => {
    initialiseData();
  }, []);

  const onEditorStateChange = (e: any) => {
    console.log(e);
    setDesciption(e);
  };

  return (
    <div className="animated fadeInRight row">
      <div className="col-md-12">
        <div className="ibox">
          <form onSubmit={(e: any) => handleSubmit(e)}>
            <div className="ibox-content">
              <div className="form-group">
                <label>
                  <h4>Page Title:</h4>
                </label>
                <input
                  value={state.title}
                  type="text"
                  placeholder="Enter Page Title"
                  className="form-control"
                  onChange={(e: any) =>
                    setState({ ...state, title: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <label>
                  <h4>Page Type:</h4>
                </label>
                <input
                  value={state.type}
                  type="text"
                  placeholder="Type must be one of [ABOUT_US, MISSION_STATEMENT, PRIVACY_POLICY, TERMS_AND_CONDITIONS]"
                  className="form-control"
                  onChange={(e: any) =>
                    setState({
                      ...state,
                      type: String(e.target.value).toUpperCase(),
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>
                  <h4>Description:</h4>
                </label>
                <div
                  style={{
                    border: "1px solid rgba(0,0,0,.2)",
                    paddingBottom: "20px",
                    background: "white",
                  }}
                >
                  <ReactQuill
                    theme="snow"
                    onChange={(e: any) => onEditorStateChange(e)}
                    placeholder={`Write your content`}
                  />
                </div>
              </div>
              <div className="form-group">
                {loading ? (
                  <Spinner />
                ) : (
                  <div className="position-relative d-inline-block">
                    {" "}
                    <img
                      className="profile-user"
                      alt={state.image_url}
                      src={
                        state.image_url
                          ? `${henceforthApi.API_FILE_ROOT_MEDIUM}${state.image_url}`
                          : Profile
                      }
                    />
                    <label className="label edit-label" htmlFor="upload-image">
                      <i className="fa fa-camera"></i>
                    </label>
                    <input
                      accept="image/*"
                      onChange={handleUpload}
                      type="file"
                      multiple
                      id="upload-image"
                      className="form-control d-none"
                    />
                  </div>
                )}
              </div>
              <div className="form-group text-end">
                <button
                  type="button"
                  className="btn btn-white btn-sm"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary-button btn-sm ms-2"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
